import { DefendantModal } from '../index';
import DeleteConfirmationModal from '../ui-control/DeleteConfirmationModal';
import EditIcon from '../../assets/icons/EditIcon.svg?react';
import AddIcon from '../../assets/icons/AddIcon.svg?react';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import useCaseDefendant from '../../hooks/useCaseDefendant';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XButton from './XButton';
import { plaintiffItemClasses, deleteBtnTiffClasses, partyCardFrameClasses } from './listItemClasses';

const columnClasses = 'col-span-12 md:col-span-6';

const headerClasses = `bg-surface-alt flex items-center justify-between
  px-4 py-2 rounded-t-md`;

const addButtonClasses = `inline-flex items-center gap-1
  text-sm font-semibold bg-transparent border-0
  px-3.5 py-2 text-primary rounded
  hover:bg-surface-alt/60`;

const itemClasses = `${plaintiffItemClasses} ${partyCardFrameClasses}`;

const itemTopRowClasses = 'flex justify-between';

const itemActionsClasses = 'flex absolute right-2.5';

const itemActionButtonClasses = deleteBtnTiffClasses;

const editIconClasses = 'h-4 w-4';

const itemMetaRowClasses = 'my-2.5 text-body text-sm';

const itemMetaRowLastClasses = 'text-body text-sm';

const CaseDefendant = () => {
  const { formik } = useAddCaseFormContext();
  const {
    addNewDefendant,
    updateDefendant,
    requestDeleteDefendant,
    confirmDeleteDefendant,
    cancelDeleteDefendant,
    pendingDeleteDefendant,
    isConfirmingDelete,
    showModal,
    selectedIndex,
    openModal,
    closeModal,
  } = useCaseDefendant();

  return (
    <>
      <DefendantModal
        show={showModal}
        onClose={closeModal}
        formik={formik}
        selectedDefendantIndex={selectedIndex}
        updateDefendant={updateDefendant}
        onSave={closeModal}
        addNewDefendant={addNewDefendant}
      />
      <DeleteConfirmationModal
        isOpen={isConfirmingDelete}
        type="defendant"
        name={pendingDeleteDefendant?.personalInfo?.name}
        onConfirm={confirmDeleteDefendant}
        onCancel={cancelDeleteDefendant}
      />

      <div className={columnClasses} data-tour={TOUR_TARGETS.CASE_DEFENDANTS}>
        <div className={headerClasses}>
          <strong>Defendants</strong>
          <button
            type="button"
            className={addButtonClasses}
            onClick={() => openModal(formik.values.defendants.length)}
          >
            <AddIcon className="text-primary" /> Add Defendant
          </button>
        </div>

        {formik.values.defendants
          ?.filter((defendant) => defendant?.personalInfo?.name)
          ?.map((defendant, index) => (
            <div key={defendant.defendantId || index} className={itemClasses}>
              <div className={itemTopRowClasses}>
                <strong>{defendant?.personalInfo?.name}</strong>
                <div className={itemActionsClasses}>
                  <XButton
                    variant="close"
                    className={`${itemActionButtonClasses} mr-6`}
                    onClick={() => openModal(index)}
                    aria-label="Edit defendant"
                  >
                    <EditIcon className={editIconClasses} />
                  </XButton>
                  <XButton
                    variant="close"
                    className={`${itemActionButtonClasses} mr-2`}
                    onClick={() => requestDeleteDefendant(index)}
                    aria-label="Delete defendant"
                  >
                    <i className="fas fa-trash-alt" />
                  </XButton>
                </div>
              </div>
              <div className={itemMetaRowClasses}>{defendant?.personalInfo?.phoneNumber}</div>
              <div className={itemMetaRowClasses}>{defendant?.personalInfo?.email}</div>
              <div className={itemMetaRowClasses}>
                Insurance: <span className="font-medium">{defendant?.insurance?.insuranceName}</span>
              </div>
              <div className={itemMetaRowClasses}>{defendant?.insurance?.adjuster?.name}</div>
              <div className={itemMetaRowClasses}>{defendant?.insurance?.adjuster?.phoneNumber}</div>
              <div className={itemMetaRowLastClasses}>{defendant?.insurance?.adjuster?.email}</div>
            </div>
          ))}
      </div>
    </>
  );
};

export default CaseDefendant;
